"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _GhostButton = _interopRequireDefault(require("../Buttons/GhostButton"));
var _useWindowResize = _interopRequireDefault(require("../_hooks/useWindowResize"));
var _mixins = require("../mixins");
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /** Initial state of the drawer */
  initialOpen: _propTypes["default"].bool,
  /** The number of pixels of the content's height, that will determine the component to add the showMore functionality */
  heightThreshold: _propTypes["default"].number,
  /** The content in the drawer*/
  children: _propTypes["default"].node,
  /** Color for the background - fade will match background's color. Cannot be transparent. Defaults to "backgroundPrimary" */
  backgroundColor: _propTypes["default"].string
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShowMoreDrawer__Wrapper",
  componentId: "sc-10xf5kt-0"
})(["", ";position:relative;width:100%;height:", ";overflow:hidden;", ""], (0, _mixins.backgroundMixin)("backgroundPrimary"), function (props) {
  return props.isOpen ? "auto" : "".concat(props.heightThreshold, "px");
}, function (props) {
  return props.hasShowMore && (0, _styledComponents.css)(["padding-bottom:32px;"]);
});
var Content = _styledComponents["default"].div.withConfig({
  displayName: "ShowMoreDrawer__Content",
  componentId: "sc-10xf5kt-1"
})(["width:100%;height:auto;"]);
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "ShowMoreDrawer__Footer",
  componentId: "sc-10xf5kt-2"
})(["", ";position:absolute;bottom:0;left:0;width:100%;padding:", ";font-size:", ";", ";", ""], (0, _mixins.backgroundMixin)("backgroundPrimary"), function (props) {
  return props.theme.spaces.xxs;
}, function (props) {
  return props.theme.fontSizes.base;
}, function (props) {
  return !props.isOpen && (0, _styledComponents.css)(["box-shadow:0 0px 24px 19px ", ";"], function (props) {
    return (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary");
  });
}, function (props) {
  return !props.hasShowMore && (0, _styledComponents.css)(["display:none;"]);
});
var ShowMoreDrawer = function ShowMoreDrawer(_ref) {
  var initialOpen = _ref.initialOpen,
    backgroundColor = _ref.backgroundColor,
    _ref$heightThreshold = _ref.heightThreshold,
    heightThreshold = _ref$heightThreshold === void 0 ? 90 : _ref$heightThreshold,
    children = _ref.children;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    hasShowMore = _useState2[0],
    setHasShowMore = _useState2[1];
  var _useState3 = (0, _react.useState)(initialOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var size = (0, _useWindowResize["default"])();
  var contentRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setHasShowMore(contentRef.current.getBoundingClientRect().height > heightThreshold);
  }, [children, heightThreshold, size.width]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    heightThreshold: heightThreshold,
    isOpen: isOpen,
    backgroundColor: backgroundColor,
    hasShowMore: hasShowMore
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    ref: contentRef
  }, children), /*#__PURE__*/_react["default"].createElement(Footer, {
    isOpen: isOpen,
    backgroundColor: backgroundColor,
    hasShowMore: hasShowMore
  }, /*#__PURE__*/_react["default"].createElement(_GhostButton["default"], {
    onClick: function onClick() {
      return setIsOpen(function (s) {
        return !s;
      });
    },
    pV: "none"
  }, isOpen ? "Show Less" : "Show More")));
};
ShowMoreDrawer.propTypes = propTypes;
var _default = ShowMoreDrawer;
exports["default"] = _default;